import i18n from '@/i18n'

const DRAFT = { id: 'DRAFT', name: 'Draf', label: 'fleetTask.status.draft' }
const SCHEDULED = { id: 'SCHEDULED', name: 'Dijadwalkan', label: 'fleetTask.status.scheduled' }
const STARTED = { id: 'STARTED', name: 'Perjalanan', label: 'fleetTask.status.started' }
const ENDED = { id: 'ENDED', name: 'Selesai', label: 'fleetTask.status.ended' }
const CANCELED = { id: 'CANCELED', name: 'Dibatalkan', label: 'fleetTask.status.canceled' }

const status = {
  DRAFT,
  SCHEDULED,
  STARTED,
  ENDED,
  CANCELED,
}

export const statusNameToIdMap = {
  [DRAFT.name]: DRAFT.id,
  [SCHEDULED.name]: SCHEDULED.id,
  [STARTED.name]: STARTED.id,
  [ENDED.name]: ENDED.id,
  [CANCELED.name]: CANCELED.id,
}

export const statusIdToNameMap = {
  [DRAFT.id]: DRAFT.name,
  [SCHEDULED.id]: SCHEDULED.name,
  [STARTED.id]: STARTED.name,
  [ENDED.id]: ENDED.name,
  [CANCELED.id]: CANCELED.name,
}

export const statusIdToLabelMap = {
  [DRAFT.id]: DRAFT.label,
  [SCHEDULED.id]: SCHEDULED.label,
  [STARTED.id]: STARTED.label,
  [ENDED.id]: ENDED.label,
  [CANCELED.id]: CANCELED.label,
}

export const statusNameToLabelMap = {
  [DRAFT.name]: DRAFT.label,
  [SCHEDULED.name]: SCHEDULED.label,
  [STARTED.name]: STARTED.label,
  [ENDED.name]: ENDED.label,
  [CANCELED.name]: CANCELED.label,
}

export const statusLabelToNameMap = {
  [DRAFT.label]: DRAFT.name,
  [SCHEDULED.label]: SCHEDULED.name,
  [STARTED.label]: STARTED.name,
  [ENDED.label]: ENDED.name,
  [CANCELED.label]: CANCELED.name,
}

export const successToastMsg = {
  [SCHEDULED.name]: () => i18n.t('fleetTaskInstant.toast.transition.status.success.scheduled'),
  [STARTED.name]: () => i18n.t('fleetTaskInstant.toast.transition.status.success.started'),
  [ENDED.name]: () => i18n.t('fleetTaskInstant.toast.transition.status.success.ended'),
  [CANCELED.name]: () => i18n.t('fleetTaskInstant.toast.transition.status.success.canceled'),
}

export const failedToastMsg = {
  [SCHEDULED.name]: () => i18n.t('fleetTaskInstant.toast.transition.status.failed.scheduled'),
  [STARTED.name]: () => i18n.t('fleetTaskInstant.toast.transition.status.failed.started'),
  [ENDED.name]: () => i18n.t('fleetTaskInstant.toast.transition.status.failed.ended'),
  [CANCELED.name]: () => i18n.t('fleetTaskInstant.toast.transition.status.failed.canceled'),
}

export default status
